export enum Active {
  active = 'Enabled',
  inactive = 'Disabled',
}

export const YesNo = {
  Yes: true,
  No: false,
};

export enum Application {
  vehicleIntelligence = 'Vehicle Intelligence',
  fleetIntelligence = 'Fleet Intelligence',
  assetIntelligence = 'Asset Intelligence',
  safetyIntelligence = 'Safety Intelligence',
  businessIntelligence = 'Business Intelligence',
}

export enum Confirmation {
  confirm = 'Confirm',
  cancel = 'Cancel',
}

export enum Action {
  create = 'create',
  edit = 'edit',
  view = 'view',
}

export enum MediaType {
  image = 'IMAGE',
  video = 'VIDEO',
  audio = 'AUDIO',
}

// Using - as they will be included in a URL
export enum IntegrationProperty {
  vendorName = 'vendor-name',
  vendorKey = 'vendor-key',
}

// Must match the DB - Used to improve readability on FE
export enum AuthTypeEnum {
  apikey = 'API Key',
  jwt = 'JWT',
  oauth = 'OAUTH',
}

// No point creating an entire table in DB for one value
export enum GrantType {
  clientCredentials = 'client_credentials',
}

export enum Status {
  published = 'PUBLISHED',
  draft = 'DRAFT',
}

// Match the access to right to the KC role name to reduce confusion
export enum AccessRight {
  Customers = 'customers',
  Integrations = 'integrations',
  Managers = 'managers',
  ProductAdmin = 'productAdmin',
  DeletePasswords = 'deletePasswords',
}

export enum UserTypes {
  SystemAdmin = 'System_Admin',
}

/**
 * Special roles from KC
 */
export enum KcUserRole {
  ProductAdmin = 'PRODUCT_ADMIN',
  DeletePasswords = 'DELETE_PASSWORDS',
}

export enum RouteData {
  PropAnyRights = 'anyRights',
  PropAllRights = 'allRights',
  PropActionTypes = 'actionTypes',
  PropBreadcrumb = 'breadcrumb',
}
